/* Product page: keeps the chosen options, the cart variant and the price in step.
   The option buttons in sections/main-product.liquid only relabel themselves,
   so this writes the matching variant into the hidden <select name="id"> the
   form submits, and shows that variant's own price. Matches options by the
   variant title each <option> already carries ("Yes (+$50)", "A / B"). */
(function(){
  var root = document.querySelector('.pdp');
  if (!root) return;
  var sel = root.querySelector('[data-variant-select]');
  if (!sel) return;
  var priceEl = root.querySelector('.price');
  var mainImg = root.querySelector('[data-main-image]');
  var prices = {};
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var fmt = function(cents){ return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: cur }); };

  try {
    (window.ShopifyAnalytics.meta.product.variants || []).forEach(function(v){ prices[v.id] = v.price; });
  } catch (err) {}

  function chosen(){
    var vals = [];
    Array.prototype.forEach.call(root.querySelectorAll('input[data-option]:checked'), function(i){
      vals[parseInt(i.dataset.option, 10) - 1] = i.value;
    });
    return vals.join(' / ');
  }

  function match(){
    var want = chosen();
    if (!want) return null;
    return Array.prototype.filter.call(sel.options, function(o){ return o.text.trim() === want; })[0] || null;
  }

  function paint(){
    var o = sel.options[sel.selectedIndex];
    if (!o) return;
    var p = prices[o.value];
    if (priceEl && p != null) priceEl.textContent = fmt(p);
    if (mainImg && o.dataset.variantImage) mainImg.src = o.dataset.variantImage;
  }

  function sync(initial){
    var o = match();
    if (!o) return;
    sel.value = o.value;
    paint();
    if (!initial && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', o.value);
      history.replaceState({}, '', url);
    }
  }

  root.addEventListener('change', function(e){
    if (e.target.closest('input[data-option]')) sync(false);
  });

  sync(true);

  // Fallback when the analytics object is missing: read the product's own JSON.
  if (!Object.keys(prices).length) {
    fetch(window.location.pathname.replace(/\/$/, '') + '.js')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p) return;
        p.variants.forEach(function(v){ prices[v.id] = v.price; });
        paint();
      })
      .catch(function(){});
  }
})();
